import { render } from "./BaseDrawer.vue?vue&type=template&id=69b3373a"
import script from "./BaseDrawer.vue?vue&type=script&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&lang=js"
script.render = render

export default script